import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { Button } from '../html/button'
import { Icon } from '../html/icon'
import { PAGINATION_GAP } from './constants'
import { paginationNumberOnly } from './helpers'
import classes from './index.module.scss'

export const SelectPage = ({
  page,
  pageSize,
  total,
  setPage,
  isShowLastButton,
}) => {
  // Get data
  const totalPage = useMemo(
    () => Math.ceil(total / pageSize),
    [total, pageSize],
  )

  const paginationList = useMemo(
    () => paginationNumberOnly(page, totalPage),
    [page, totalPage],
  )

  // Actions
  const onClickFirstButton = () => {
    if (page === 1) return
    setPage(1)
  }

  const onClickLastButton = () => {
    if (page === totalPage) return
    setPage(totalPage)
  }

  const onClickPrevButton = () => {
    if (page === 1) return
    setPage(page - 1)
  }

  const onClickNextButton = () => {
    if (page === totalPage) return
    setPage(page + 1)
  }

  const onClickPageButton = (value) => {
    if (value === PAGINATION_GAP || value === page) return
    setPage(value)
  }

  return (
    <div className="dFlex alignItemsCenter">
      <Button
        label="common.pagination.FIRST"
        className={[
          'cursorPointer dFlex alignItemsCenter',
          classes.paginationButton,
        ].join(' ')}
        action={onClickFirstButton}
        isI18n
        style={{
          backgroundColor: '#F3F3F3',
          color: page === 1 ? '#9c9c9c' : 'inherit',
        }}
      />
      <Button
        label={<Icon className="icon-arrow-left" />}
        className={[
          'cursorPointer dFlex alignItemsCenter',
          classes.paginationButton,
        ].join(' ')}
        action={onClickPrevButton}
        style={{
          backgroundColor: '#F3F3F3',
          color: page === 1 ? '#9c9c9c' : 'inherit',
        }}
      />
      {paginationList.map((item, index) => (
        <Button
          key={index}
          label={item}
          className={[
            'cursorPointer dFlex alignItemsCenter',
            classes.paginationButton,
          ].join(' ')}
          style={{
            backgroundColor: page === item ? '#FFFFFF' : '#F3F3F3',
            borderWidth: page === item && 1,
            borderStyle: page === item && 'solid',
            borderColor: page === item && '#2c73e8',
            color: page === item ? '#2c73e8' : 'inherit',
          }}
          action={() => onClickPageButton(item)}
        />
      ))}
      <Button
        label={<Icon className="icon-arrow-right" />}
        className={[
          'cursorPointer dFlex alignItemsCenter',
          classes.paginationButton,
        ].join(' ')}
        action={onClickNextButton}
        style={{
          backgroundColor: '#F3F3F3',
          color: page === totalPage ? '#9c9c9c' : 'inherit',
        }}
      />
      {isShowLastButton && (
        <Button
          label="common.pagination.LAST"
          className={[
            'cursorPointer dFlex alignItemsCenter',
            classes.paginationButton,
          ].join(' ')}
          action={onClickLastButton}
          isI18n
          style={{
            backgroundColor: '#F3F3F3',
            color: page === totalPage ? '#9c9c9c' : 'inherit',
          }}
        />
      )}
    </div>
  )
}

SelectPage.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  isShowLastButton: PropTypes.bool,
}

SelectPage.defaultProps = {
  page: 1,
  pageSize: 20,
  total: 0,
  setPage: () => {},
  isShowLastButton: true,
}
